module.exports = {
      id: "environment-usage",
      viewBox: "0 0 28.781 28.787",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#environment",
      toString: function () {
        return this.url;
      }
    }